import { forwardRef } from 'react';

import { Avatar } from '../../Avatar';
import { Button } from '../../Button/Button';
import { Popover, PopoverActions } from '../../Popover';

import styles from './ParametersPopup.module.scss';
import { Props } from './ParametersPopup.types';

export const ParametersPopup = forwardRef<PopoverActions, Props>(
  ({ user, onLogout, children, version, ...popupProps }, ref) => {
    const fullName = [user?.given_name, user?.family_name].filter(Boolean).join(' ');

    return (
      <Popover
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        className={styles.popover}
        {...popupProps}
        ref={ref}
      >
        <Avatar size="medium" color="blue" content={user} />
        <div>
          {fullName && <div className={styles.name}>{fullName}</div>}
          {user?.nickname && <div className={styles.subText}>{user.nickname}</div>}
          {user?.email && <div className={styles.subText}>{user.email}</div>}
        </div>
        <div className={styles.children}>{children}</div>
        <Button variant="secondary" onClick={onLogout}>
          déconnexion
        </Button>
        {version && <div className={styles.version}>version : {version}</div>}
      </Popover>
    );
  }
);
